import NextI18Next from 'next-i18next'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
import path from 'path'
import missingInterpolationHandler from './utils/missingInterpolationHandler'

const { localeSubpaths } = publicRuntimeConfig

const S18N = new NextI18Next({
    defaultLanguage: 'en',
    fallbackLng: 'en',
    returnEmptyString: false,
    otherLanguages: ['en', 'es', 'fr', 'ltg', 'tl', 'km'],
    localeSubpaths: localeSubpaths as Record<string, string>,
    localePath: path.resolve('./public/locales'),
    debug: process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === 'development',
    initImmediate: false,
    missingInterpolationHandler: missingInterpolationHandler,
})

if (typeof window !== 'undefined') {
    window.S18N = S18N.i18n
}

export const s18n = S18N.i18n
export const appWithTranslation = S18N.appWithTranslation
export const useTranslation = S18N.useTranslation
export const Trans = S18N.Trans
